import { Component, OnInit} from '@angular/core';
import { AuthenticationService } from '../common-services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';

// Angular component to hand authentication
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
 
    model: any = {};
    loading : boolean;
    returnUrl: string;
    errorHandler: ErrorHandler = new ErrorHandler;
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private messagesService: MessagesService
        ) { 
            this.loading= false;
        }
 
    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
        
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/masterdata';
    }
 
    // performs login on click of login button
    login() {
        this.loading = true;   

        //TO BE REMOVED
        console.log("URL rerouting.. "+this.returnUrl)
        localStorage.setItem('currentUser', 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJrN2JsIiwiaWF0IjoxNTk0MjEwMTYxLCJleHAiOjE1OTQyMTczNjF9.VNvgLtCh1jiTSG0LEbIu80sRQ0lqzObqerjbqo8_iGaASgySmdHfFynyu2wWL0QanLiqw8OGJw-6MJY3DpT5dQ')
        localStorage.setItem('PUID', "PUID");
        this.router.navigate([this.returnUrl]);
    }

    

}
